import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FileDragAndDropComponent } from './file-drag-and-drop.component';

@NgModule({
  imports: [CommonModule],
  declarations: [FileDragAndDropComponent],
  exports: [FileDragAndDropComponent],
})
export class FileDragAndDropModule {}
